// extracted by mini-css-extract-plugin
export default {"item":"FilterSelect_item__Aqlsu"};